'use server'

import { apiRequest, ApiResponse } from '../request'

export type TussSource = 'IMPORTED' | 'MANUAL'

export interface TussCode {
    id: number
    code: string
    term: string
    description: string | null
    validityStart: string | null
    validityEnd: string | null
    implementationEnd: string | null
    source: TussSource
    active: boolean
    createdAt: string
    updatedAt: string
}

export interface TussFilters {
    page?: number
    limit?: number
    search?: string
    source?: TussSource
    active?: 'true' | 'false'
}

export interface CreateTussPayload {
    code: string
    term: string
    description?: string
    validityStart?: string
    validityEnd?: string
    implementationEnd?: string
    active?: boolean
}

export type UpdateTussPayload = Partial<CreateTussPayload>

const BASE = 'tuss'

export async function getTussCodes(
    filters: TussFilters,
): Promise<ApiResponse<TussCode[]>> {
    return apiRequest<TussCode[]>(BASE, { params: filters })
}

/**
 * Busca rápida de códigos TUSS (autocomplete). Endpoint autenticado (não
 * exige master), usado pelo seletor de TUSS na unificação de catálogo.
 */
export async function searchTussCodes(
    q: string,
    limit = 20,
): Promise<ApiResponse<TussCode[]>> {
    return apiRequest<TussCode[]>(`${BASE}/search`, { params: { q, limit } })
}

export async function createTussCode(
    data: CreateTussPayload,
): Promise<ApiResponse<TussCode>> {
    return apiRequest<TussCode>(BASE, { data }, 'post')
}

export async function updateTussCode(
    id: number,
    data: UpdateTussPayload,
): Promise<ApiResponse<TussCode>> {
    return apiRequest<TussCode>(`${BASE}/${id}`, { data }, 'patch')
}

export async function deleteTussCode(
    id: number,
): Promise<ApiResponse<{ removed: boolean }>> {
    return apiRequest(`${BASE}/${id}`, {}, 'delete')
}
